export interface StockAlertRequest {
  product_id: number;
  email: string;
}

export interface StockAlertResponse {
  id: number;
  product_alert_id: number;
  email: string;
  token: string;
  created_at?: string;
  updated_at?: string;
}

export interface StoredStockAlert {
  token: string;
  email: string;
  product_id: number;
  subscribed_at: string;
}

export type StockAlertErrorReason =
  | 'product_not_found'
  | 'product_has_stock'
  | 'product_unavailable'
  | 'product_is_prepurchase'
  | 'already_subscribed'
  | 'token_not_found'
  | 'unknown';

export class StockAlertError extends Error {
  constructor(public readonly reason: StockAlertErrorReason, message: string) {
    super(message);
    this.name = 'StockAlertError';
  }
}
